import type { SxProps } from '@mui/system';
import type { TypographySystemOverrides, TypographySystem } from '@mui/joy';

export const ERROR_VARIANTS = ['inline', 'centered-panel', 'fullscreen'] as const;
export type ErrorVariant = (typeof ERROR_VARIANTS)[number];

type TypographyLevel = keyof (TypographySystemOverrides & TypographySystem);

export const errorLayoutPresets: Record<ErrorVariant, { sx: SxProps; headerLevel: TypographyLevel }> = {
  inline: {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      height: 'auto',
      minHeight: 'auto',
      justifyContent: 'flex-start',
      padding: 1,
      width: 'auto',
    },
    headerLevel: 'title-md',
  },
  'centered-panel': {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: 2,
      minHeight: 300,
      height: '100%',
      width: 'fullWidth',
    },
    headerLevel: 'h2',
  },
  fullscreen: {
    sx: {
      position: 'fixed',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '100vw',
      height: '100vh',
      '& > *': {
        maxWidth: '32rem',
      },
    },
    headerLevel: 'h2',
  },
};

export const getErrorLayout = (variant: ErrorVariant): { sx: SxProps; headerLevel: TypographyLevel } => {
  return errorLayoutPresets[variant];
};
